import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {getStorageValue,Regex,} from "../../service/shared.service";
import InputMask from 'react-input-mask';
import { Spinner } from "react-bootstrap";
import toastr from "../elements/toast";
import httpApiCall from "../../service/api.service";


const SendReminderModal = ({onClose, onConfirm,reminderData,mobileCode,mobileRegex ,type}) => {
    const [sppiner, setSppiner] = useState(false);
    const [doctorMobile, setDoctorMobile] = useState();
    const langList = [{value: 'en',label: "English"},{value: 'de',label: "Deutsch"},{value: 'es',label: "Español"},{value: 'fr',label: "Französisch"},
        {value: 'it',label: "Italiano"}, {value: 'ja',label: "日本語"},{value: 'pl',label: "Polski"},{value: 'ru',label: "Русский"}]
        const toastrService = new toastr(true);
        

const onPhoneChange = (event, setFieldValue) => {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    }
    // setDirectInvite((businessData) => ({
    //     ...businessData,
    //     doctor_mobile: event.target.value
    // }));
    setFieldValue('doctor_mobile', event.target.value);
    setDoctorMobile(event.target.value)
};

const [directInvite, setDirectInvite] = useState({
    doctor_first_name: reminderData?.name||'',
    doctor_email: reminderData?.referral_email||'',
    doctor_mobile: "",
    doctor_mobile_country_code: "",
    language_preffered: "en",
    notes:''
});


const directInviteValidation = Yup.object({
    doctor_first_name: Yup.string().required("Please enter name").matches(Regex.name, 'Invalid name'),
    doctor_email: Yup.string().email("Invalid email format").matches(Regex.email, "Please enter a valid email"),
    doctor_mobile: Yup.string(),
    // language_preffered: Yup.string().required("Please select language"),
    notes: Yup.string().required("Please enter note"),
    
  });

  const handleReminderSubmit = async (formData) => {
    if ((formData.doctor_first_name).length > 100) {
      toastrService.showError('Please enter valid name');
      return;
    }
    if ((!formData.doctor_email.trim().length)&& (formData.doctor_mobile.trim().length<6)) {
      toastrService.showError('Please enter valid phone no or email');
      return;
    }
    const profileData = getStorageValue("partnerProfile");
    const body = {
      access_token: getStorageValue("partnerToken"),
      invite_email: formData.doctor_email||null,
      // invite_name: formData.doctor_first_name,
      invite_mobile: formData.doctor_mobile,
      invite_mobile_country_code: formData.doctor_mobile ? mobileCode : '',
      language_preffered:"en",
      notes:formData.notes,
      is_resend_reminder:1,
      referral_code:profileData && profileData.length? profileData[0]["referral_code"]: "",
      referral_name:formData.doctor_first_name,
      is_agent: type==='SubPartner'?1:0,
      referral_parent_id:reminderData?.id
    };
    
    setSppiner(true);
    let resp = await httpApiCall({ api: "send_invite", type: "post", body });
    setSppiner(false);
    if (resp && !resp.is_error) {
      setDirectInvite({
        doctor_first_name: "",
        doctor_email: "",
        doctor_mobile: "",
        doctor_mobile_country_code: "",
        language_preffered: "en",
        notes:''
      });
      toastrService.showSuccess("Reminder has been sent successfully");
      onConfirm(true);
    } else {
        toastrService.showError(resp.original_text || resp.err);
    }
  };
  useEffect(() => {
    setDoctorMobile(null)
    if (reminderData) {
      setDoctorMobile(reminderData.referral_mobile.split('-')[1])
      setDirectInvite({
        doctor_first_name: reminderData.referral_name || '',
        doctor_email: reminderData.referral_email || '',
        doctor_mobile: reminderData.referral_mobile? reminderData.referral_mobile.split('-')[1]:'',
        doctor_mobile_country_code: "",
        language_preffered: "en",
        notes: reminderData.notes
      });
      // setMobileCode(reminderData.doctor_mobile_country_code || ''); // if needed
    }
  }, [reminderData]);
  

  return (
    <div style={styles.overlay}>
        <div style={styles.modal}>
            <div style={styles.headerModal}>
                <span>Send Reminder</span>
                <span onClick={onClose} className='closeReminder'><FaTimes /></span>
            </div>
            <div className="modal-body p-4" style={styles.bodyModal}>
                <div className="form-group formBody">
                    <Formik
                        onSubmit={handleReminderSubmit}
                        initialValues={directInvite}
                        enableReinitialize={true}
                        validationSchema={directInviteValidation}
                        >
                        {({ setFieldValue }) => (
                            <Form>
                                <div className="row">
                                    <div className="col-lg-12">
                                    <div className="form-group">
                                        <label htmlFor="" className="labels_input">
                                        {type==='Business'?'Business':'Sub partner'} Name
                                        </label>
                                        <Field
                                        className="form-control"
                                        id="business_first_name"
                                        type="text"
                                        name="doctor_first_name"
                                        placeholder={`Enter ${type==='Business'?'business':'sub partner'} name`}
                                        autoComplete="doctor_first_name"
                                        />
                                        <small className="text-danger m-2">
                                        <ErrorMessage name="doctor_first_name" />
                                        </small>
                                    </div>
                                    </div>
                                    
                                    <div className="col-lg-12">
                                    <div className="form-group">
                                        <label htmlFor="" className="labels_input">
                                        {type==='Business'?'Business':'Sub Partner'} E-mail
                                        </label>
                                        <Field autoComplete="doctor_email"
                                        className="form-control"
                                        type="email"
                                        id="business_email"
                                        name="doctor_email"
                                        placeholder={`Enter ${type==='Business'?'business':'sub partner'} email`}
                                        readOnly={!!reminderData?.referral_email}
                                        style={
        !!reminderData?.referral_email
          ? { background: '#F2F5F8' }
          : {}
      }
                                        />
                                        <small className="text-danger m-2">
                                        <ErrorMessage name="doctor_email" />
                                        </small>
                                    </div>
                                    </div>
                                    <div className="col-lg-12">
                                    {mobileRegex && <div className="form-group">
                                        <label htmlFor="" className="labels_input">
                                        {type==='Business'?'Business':'Sub Partner'} Phone
                                        </label>
                                        <div className="mobilecode">
                                        <p>{mobileCode}</p>
                                        <div className="hide_show">
                                            <Field 
                                            name="doctor_mobile"
                                            className="form-control invite"
                                            id="doctor_mobile"
                                            >
                              {
                                (props) => <InputMask
                                  type="text"
                                  mask={mobileRegex.phoneRegexLength}
                                  name="doctor_mobile"
                                  maskChar={null}
                                  className="text-input form-control"
                                  id="doctor_mobile"
                                  onChange={(event) => onPhoneChange(event, setFieldValue)}
                                  readOnly={!!reminderData?.referral_mobile}
                                  value={doctorMobile}
                                  minLength={+mobileRegex.min_phone_length}
                                  maxLength={+mobileRegex.phone_length}
                                  style={
                                    !!reminderData?.referral_mobile
                                      ? { background: '#F2F5F8' }
                                      : {}
                                  }
                                />
                              }
                                            </Field>
                                        </div>
                                        </div>
                                        <small className="text-danger m-2">
                                        <ErrorMessage name="doctor_mobile" />
                                        </small>
                                    </div>}
                                    </div>
                                    {/* <div className="col-lg-12">
                                    <div className="form-group arrowSelect">
                                        <label htmlFor="" className="labels_input">
                                        Select Preferred Language
                                        </label>
                                        <Field
                                        className="form-control"
                                        as="select"
                                        name="language_preffered"
                                        id="language_preffered"
                                        onChange={(event) => {
                                        setDirectInvite((data) => ({
                                          ...data,
                                          language_preffered: event.target.value
                                        }))
                                        setFieldValue("language_preffered", event.target.value)
                                      }}
                                      value={directInvite.language_preffered}
                                        >
                                        <option disabled key={0} value={""}>
                                            {"Select preferred language"}
                                        </option>
                                        {langList.map((e, i) => (
                                            <option key={i} value={e.value}>
                                            {e.label}
                                            </option>
                                        ))}
                                        </Field>
                                        <small className="text-danger m-2">
                                        <ErrorMessage name="language_preffered" />
                                        </small>
                                    </div>
                                    </div> */}
                                    <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="" className="labels_input">Notes</label>
                                        <Field
                                            className="form-control"
                                            as="textarea"
                                            id="notes"
                                            name="notes"
                                            rows="5"
                                            cols="40"
                                            />
                                        <small className="text-danger m-2">
                                            <ErrorMessage name="notes" />
                                        </small>
                                    </div>
                                    </div>
                                </div>
                            <div className="button_chase">
                                <button disabled={sppiner} className="loginBtn" type="submit">
                                    Send Reminder 
                                    {sppiner && (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="ms-2"
                                    />
                                    )}
                                </button>
                            </div>
                        </Form>
                        )}
                    </Formik>
            
                </div>
            </div>
        </div>
    </div>
  );
};

SendReminderModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  },
  modal: {
    backgroundColor: 'white',
    padding: '0px',
    borderRadius: '8px',
    width: '500px',
    minHeight:'300px',
    maxHeight:'80vh',
    overflow:'scroll'
  },
  headerModal: {
    padding: '15px',
    textAlign: 'left',
    background:' #073c4f',
    color:' #fff',
    fontSize: '20px',
    fontWeight:'600',
    borderTopLeftRadius:'8px',
    borderTopRightRadius: '8px',
    display:'flex',
    justifyContent:'space-between'
  },
  bodyModal:{
    maxHeight:'75vh',
    overflow:'scroll'
  },
  button: {
    padding: '10px 20px',
    borderRadius: '4px',
    margin:'10px',
    cursor: 'pointer',
    border: 'none',
  },
};

export default SendReminderModal;
